import React, { useState, useEffect } from "react"
import { PieChart, pieArcClasses } from "@mui/x-charts/PieChart"
import { pieClasses } from "@mui/x-charts/PieChart"
import "./VAPieChart2.css"

export default function VAPieChart2({ chartData1, chartData2, children }) {
  const settings = {
    series: [
      {
        innerRadius: 20,
        outerRadius: 120,
        data: chartData1,
        highlightScope: { fade: "global", highlight: "item" },
        faded: { innerRadius: 10, additionalRadius: -40, color: "gray" },
        startAngle: 0,
        endAngle: 360,
        paddingAngle: 5,
        cornerRadius: 5,
      },
      // {
      //   id: "outer",
      //   innerRadius: 100,
      //   outerRadius: 120,
      //   data: chartData2,
      //   highlightScope: { fade: "global", highlight: "item" },
      //   paddingAngle: 5,
      //   cornerRadius: 5,
      //   startAngle: -75,
      //   endAngle: 225,
      //   // cx: 150,
      //   // cy: 150,
      // },
    ],
    height: 300,
    hideLegend: false,
  }

  return (
    <div id="VAPieChart2">
      <PieChart
        {...settings}
        sx={{
          [`[data-series="outer"] .${pieArcClasses.root}`]: {
            opacity: 0.6,
          },
        }}
        //   series={[
        //     {

        //       innerRadius: 30,
        //       outerRadius: 70,
        //       paddingAngle: 5,
        //       cornerRadius: 5,
        //       startAngle: -45,
        //       // endAngle: 225,
        //       cx: 150,
        //       // cy: 150,
        //     },
        //   ]}
      />
      {children}
    </div>
  )
}
